export const GET_PILOTAGE_VOLUME_WITH_PAGINATION = 'GET:PILOTAGE:VOLUME:WITH:PAGINATION';
export const CREATE_PILOTAGE_VOLUME = 'CREATE:PILOTAGE:VOLUME';
export const UPDATE_PILOTAGE_VOLUME = 'UPDATE:PILOTAGE:VOLUME';
export const UPDATE_ALL_PILOTAGE_VOLUME = 'UPDATE:ALL:PILOTAGE:VOLUME';
export const DELETE_PILOTAGE_VOLUME = 'DELETE:PILOTAGE:VOLUME';
export const DELETE_ALL_PILOTAGE_VOLUME = 'DELETE:ALL:PILOTAGE:VOLUME';
export const SEARCH_PILOTAGE_VOLUME = 'SEARCH:PILOTAGE:VOLUME';
